import React, { useEffect, useState } from 'react'
import useStore from '../../../../../../store/useStore';
import { useMutation } from '@apollo/client';
import { ALL_YOUTUBE_VIDEO, UpdateYouTubeVideo, useAllYouTubeVideo } from '../../../../../../graphql';
import FailAlert from '../../../../../../components/Alerts/FailAlert';
import LoadingWidget from '../../../../../../components/LoadingWidget/LoadingWidget';
import { MdClose } from 'react-icons/md'
import { t } from 'i18next';

interface Props {
  setEditVideosPopup: React.Dispatch<React.SetStateAction<boolean>>,
  setSuccessMsg: React.Dispatch<React.SetStateAction<string>>,
  setSuccess: React.Dispatch<React.SetStateAction<boolean>>,
}

const EditYoutubeVideo = ({ setEditVideosPopup, setSuccess, setSuccessMsg }: Props) => {
  const storeData = useStore((state: any) => state.userData.store);

  const [id, setId] = useState("");

  const [fail, setFail] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  const [link, setLink] = useState("");

  // i had to use a main state for control loading because of ui issues
  const [initialLoading, setInitialLoading] = useState(true);

  const [allYouTubeVideo, { loading, data: dataAllYouTubeVideo }] = useAllYouTubeVideo();

  // update
  const [updateYouTubeVideo, { error, loading: updateLoading }] = useMutation(UpdateYouTubeVideo);

  useEffect(() => {
    if (storeData) {
      (async () => {
        await allYouTubeVideo({
          variables: { idStore: storeData.id }
        })

        setInitialLoading(false)
      })()
    }

  }, [storeData]);

  useEffect(() => {
    if (dataAllYouTubeVideo?.allYouTubeVideo !== undefined && dataAllYouTubeVideo?.allYouTubeVideo !== null) {
      setLink(dataAllYouTubeVideo.allYouTubeVideo.link)
      setId(dataAllYouTubeVideo.allYouTubeVideo.id)
    }
  }, [dataAllYouTubeVideo])

  const submit = async (e: any) => {
    e.preventDefault();

    if (link === "") {
      setFailMsg(t('invalidLink'))
      setFail(true)
      return
    }

    await updateYouTubeVideo({
      variables: {
        updateYouTubeVideoId: id,
        content: {
          idStore: storeData.id,
          link: link
        }

      },
      refetchQueries: [{ query: ALL_YOUTUBE_VIDEO, variables: { idStore: storeData.id } }]
    })


    if (!error) {
      setSuccessMsg(t('youtubeVideoAddsuccess'));
      setSuccess(true);
      setEditVideosPopup(false)
    }
  }

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center w-full min-h-screen py-6 bg-gray-900/10 backdrop-blur-md'>

      {fail && <FailAlert fail={fail} setFail={setFail} failMsg={failMsg} />}

      <div className='w-5/6 p-2 bg-white border sm:w-4/6 md:w-3/6 rounded-md'>
        {initialLoading ?
          <LoadingWidget />
          :
          loading ?
            <LoadingWidget />
            :
            <div>
              {
                updateLoading &&
                <div className='absolute top-0 left-0 z-30 flex items-center justify-center w-full h-full py-10 bg-white/70'>
                  <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                  </svg>
                </div>
              }

              <div className='flex justify-end py-2 text-gray-600'>
                <div onClick={() => setEditVideosPopup(false)} className='cursor-pointer'>
                  <MdClose size={20} />
                </div>
              </div>

              <div className="my-2">
                <label htmlFor="link" className="block mb-2 text-sm font-medium text-gray-900">{t('title')}</label>
                <input type="text" id="link" value={link} onChange={(e) => setLink(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('title')} required />
              </div>

              <div className='flex justify-end my-2'>
                <div>
                  <button onClick={(e) => { submit(e) }} className='inline-flex items-center justify-center px-4 py-2 my-2 overflow-hidden text-sm text-white transition-colors duration-300 rounded-lg shadow bg-primary sm:w-auto md:my-0 hover:bg-primaryHover'>
                    <span className="mx-2">
                      {t('save')}
                    </span>
                  </button>
                </div>
              </div>
            </div>
        }
      </div>
    </div>
  )
}

export default EditYoutubeVideo